import classNames from "classnames";
import PropTypes from "prop-types";
import { buttonLinkPropTypes } from "utils/types";

import CustomLink from "./custom-link";

const ButtonContent = ({
  button,
  appearance,
  compact,
  updated,
  size,
  className,
}) => {
  if (updated) {
    return (
      <button
        disabled={appearance === "disabled"}
        className={classNames(
          "text-center text-lg md:text-base rounded-full border border-2 border-onmoPrimary h-[55px] md:h-[52px] font-medium",
          {
            "bg-onmoPrimary text-white": appearance === "primary",
          },
          {
            "text-onmoPrimary bg-transparent": appearance === "secondary",
          },
          {
            "text-onmoPrimary bg-transparent": appearance === "disabled",
          },
          {
            "text-white bg-onmoGreen border-onmoGreen bg-transparent":
              appearance === "alternative",
          },
          {
            "w-full md:w-[200px]": size === "large",
          },
          {
            "w-full md:w-[188px]": size === "medium",
          },
          {
            "w-full md:w-[170px]": size === "small",
          },
        )}
      >
        {button.text}
      </button>
    );
  }
  return (
    <div
      className={classNames(
        // Common classes
        `block w-full lg:w-auto text-center tracking-wide font-semibold text-base md:text-lg rounded-full border border-2 border-onmoPrimary ${className}`,
        // Full-size button
        {
          "min-w-full py-4": compact === false,
        },
        // Compact button
        {
          "px-6 py-2": compact === true,
        },
        // Specific to when the button is fully dark
        {
          "bg-onmoPrimary text-white": appearance === "primary",
        },
        // Specific to when the button is dark outlines
        {
          "text-onmoPrimary bg-transparent": appearance === "secondary",
        },
        {
          "text-black bg-secondaryBrown border-secondaryBrown":
            appearance === "alternative",
        },
        // Specific to when the button is fully white
        {
          "bg-white text-primary-600 border-white": appearance === "white",
        },
        // Specific to when the button is white outlines
        {
          "text-white border-white": appearance === "white-outline",
        },
      )}
    >
      {button.text}
    </div>
  );
};

const ButtonLink = ({
  button,
  appearance,
  updated,
  size,
  compact = false,
  className = "",
  isBrandRefresh = false,
}) => {
  return (
    <CustomLink link={button}>
      {isBrandRefresh ? (
        <div
          className={`block w-full lg:w-auto text-center tracking-wide  ${className}`}
        >
          {button.text}
        </div>
      ) : (
        <ButtonContent
          size={size}
          updated={updated}
          button={button}
          appearance={appearance}
          compact={compact}
          className={className}
        />
      )}
    </CustomLink>
  );
};

ButtonLink.propTypes = {
  button: buttonLinkPropTypes,
  appearance: PropTypes.oneOf([
    "primary",
    "secondary",
    "alternative",
    "disabled",
  ]),
  size: PropTypes.oneOf(["large", "medium", "small"]),
  compact: PropTypes.bool,
  updated: PropTypes.bool,
};

export default ButtonLink;
